import React, { useContext, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import type { LayerDescriptionV2 } from '@volkswagen-onehub/layer-manager';
import { SYS_COLOR_SURFACE_SCRIM_DEFAULT_LIGHT } from '@oneaudi/unified-web-common';
import { oneLayerTimingsConfig } from './globals';
import { AppContext } from '../context/app';

interface ShaderProps {
  zIndex?: number;
  layers?: LayerDescriptionV2<unknown>[];
  featureAppId: string;
}

const openKeyFramesShader = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const ShaderStyled = styled.div<ShaderProps>`
  animation-duration: ${oneLayerTimingsConfig.L}ms;
  animation-name: ${openKeyFramesShader};
  animation-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  background-color: ${SYS_COLOR_SURFACE_SCRIM_DEFAULT_LIGHT};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  ${({ zIndex }): string => `z-index: ${zIndex};`};
`;

const Shader: React.FC<ShaderProps> = (props) => {
  const { layers, featureAppId } = props;
  const { historyService } = useContext(AppContext);

  useEffect(() => {
    historyService.rootHistory.replace(location.href, { id: featureAppId });
    const hasDeepLink =
      historyService.rootHistory?.location?.hash?.includes('#one-layer=') ||
      historyService.rootHistory?.location?.hash?.includes('#oneLayer=');
    return (): void => {
      if (
        // @ts-expect-error the id is not typed
        historyService.rootHistory?.location?.state?.id === featureAppId &&
        hasDeepLink
      ) {
        historyService.rootHistory.back();
      }
    };
  }, []);

  useEffect(() => {
    const closeAll = (): void => {
      let i: number;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      for (i = layers.length - 1; i > -1; i -= 1) {
        if (layers) {
          layers[i]?.layer?.close();
        }
      }
    };
    /* istanbul ignore next */
    window?.addEventListener('popstate', closeAll, false);
    return (): void => {
      /* istanbul ignore next */
      window?.removeEventListener('popstate', closeAll, false);
    };
  }, [layers]);

  return <ShaderStyled {...props} />;
};

export default Shader;
